import React from 'react';
import { Row, Col, Textarea } from '@si-armes/dsfr-react';
import InputFiles from 'components/Commun/Form/InputFiles';
import { useFormContext } from 'react-hook-form';

const FormulaireContactGenerique = () => {
    const hookForm = useFormContext();
    const { register, formState } = hookForm;
    return (
        <>
            <Row gutters className="margin-bottom-sm">
                <Col col={12}>
                    <label className="fr-label" htmlFor="message">
                        Votre message *
                    </label>
                    <p className="fr-hint-text">
                        Veuillez saisir votre message (4000 caractères maximum){' '}
                    </p>
                    <Textarea
                        id="message"
                        name="message"
                        maxlength="4000"
                        {...register('message', {
                            required: 'Ce champ est obligatoire',
                        })}
                        required
                    />
                </Col>
            </Row>
            <Row gutters className="margin-bottom-md">
                <Col>
                    <InputFiles
                        label="Si nécessaire vous pouvez joindre un ou plusieurs fichiers"
                        name="piecesJointes"
                        multiple
                        error={formState.errors ? formState.errors.piecesJointes : null}
                    />
                </Col>
            </Row>
        </>
    );
};

export default FormulaireContactGenerique;
